import { setLoadPage } from 'store/autoReducers';
import { Action } from 'store/createReducer';

let actionsCache: Action[] | null = null;
export const hasActionsCache = (): boolean => !!actionsCache;

export const inject = (data: Action[]): void => {
    actionsCache = [...data, setLoadPage(false)];
};

export const extract = <T extends Action>(originalAction: T): (T | Action)[] | T => {
    if (!actionsCache) {
        return originalAction;
    }

    const actions = actionsCache;
    actionsCache = null;

    if (originalAction) {
        actions.push(originalAction);
    }

    return actions;
};
